"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PVoter = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var PCredential_1 = require("../../V1/Address/PCredential.js");
var PPubKeyHash_1 = require("../../V1/PubKey/PPubKeyHash.js");
exports.PVoter = (0, pstruct_1.pstruct)({
    Committee: { hotCredentials: PCredential_1.PCredential.type },
    DRep: { credentials: PCredential_1.PCredential.type },
    StakePool: { poolHash: PPubKeyHash_1.PPubKeyHash.type }
});
